import { useState, useEffect } from 'react';
import { getExperimental, createExperimental, updateExperimental, deleteExperimental, ResearchArticle } from '../lib/supabase';

export function useSupabaseExperimental() {
  const [articles, setArticles] = useState<ResearchArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadArticles = async () => {
    try {
      setLoading(true);
      const data = await getExperimental();
      setArticles(data);
      setError(null);
    } catch (err: any) {
      setError(err.message);
      setArticles([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadArticles();
  }, []);

  const addArticle = async (articleData: Omit<ResearchArticle, 'id' | 'created_at' | 'updated_at'>) => {
    const created = await createExperimental(articleData);
    await loadArticles();
    return created;
  };

  const updateArticle = async (id: string, articleData: Partial<ResearchArticle>) => {
    const updated = await updateExperimental(id, articleData);
    await loadArticles();
    return updated;
  };

  const deleteArticle = async (id: string) => {
    await deleteExperimental(id);
    await loadArticles();
  };

  return { articles, loading, error, addArticle, updateArticle, deleteArticle, refreshArticles: loadArticles };
}
